import * as Toggle from '@radix-ui/react-toggle-group'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation } from 'types'

const SeverityContainer = styled(Toggle.Root)`
  display: flex;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  overflow: hidden;
  justify-items: center;
  width: fit-content;
  background-color: rgb(60, 60, 60);
`

const StyledSeverityOption = styled(Toggle.Item)<{ $selected: boolean }>`
  all: unset;
  cursor: ${({ $selected }) => ($selected ? 'auto' : 'pointer')} !important;
  background-color: ${({ theme, $selected }) =>
    $selected
      ? theme.forecast.background4
      : theme.forecast.background2} !important;
  opacity: 0.8 !important;
  height: 30px !important;
  width: 36px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  &:hover {
    opacity: ${({ $selected }) => ($selected ? 0.8 : 1)} !important;
    background-color: ${({ theme, $selected }) =>
      $selected
        ? theme.forecast.background4
        : theme.forecast.background3} !important;
  }
`

const SeverityOptionButton: FC<{
  value: string
  currentSeverity: string
}> = ({ value, currentSeverity }) => {
  return (
    <StyledSeverityOption value={value} $selected={value === currentSeverity}>
      {value}
    </StyledSeverityOption>
  )
}

export const SeverityPicker: FC<{
  editedAnnotation: KVAnnotation
  setEditedAnnotation: React.Dispatch<React.SetStateAction<KVAnnotation>>
}> = ({ editedAnnotation, setEditedAnnotation }) => {
  const setSeverity = (s: string) => {
    setEditedAnnotation((prev) => ({
      ...prev,
      severity: s,
    }))
  }

  return (
    <SeverityContainer
      type='single'
      value={editedAnnotation.severity}
      aria-label='Select severity'
      onClick={(event) => event.stopPropagation()}
      onValueChange={(value) => {
        // Check for undefined to prevent deselecting all options
        if (value) setSeverity(value)
      }}>
      <SeverityOptionButton
        value={'1'}
        currentSeverity={editedAnnotation.severity}
      />
      <SeverityOptionButton
        value={'2'}
        currentSeverity={editedAnnotation.severity}
      />
      <SeverityOptionButton
        value={'3'}
        currentSeverity={editedAnnotation.severity}
      />
      <SeverityOptionButton
        value={'4'}
        currentSeverity={editedAnnotation.severity}
      />
      <SeverityOptionButton
        value={'5'}
        currentSeverity={editedAnnotation.severity}
      />
    </SeverityContainer>
  )
}
